module.exports = __webpack_public_path__ + "img/stock6.55148cf0.png";